import React from "react";
import { Container, Row, Col } from "reactstrap";
import nCountLogo from "../assets/logos/Header Logo.png";

function Header({ title, subtitle, rightContent }) {
  return (
    <header className="home-header">
      <Container fluid>
        <Row className="align-items-center">
          <Col xs="12" md="6" className="d-flex align-items-center">
            <img src={nCountLogo} alt="nCount" className="home-header-logo" />
          </Col>
          <Col xs="12" md="6" className="text-md-end mt-2 mt-md-0">
            {rightContent ? (
              rightContent
            ) : (
              <>
                {title && <h3 className="home-title mb-0">{title}</h3>}
                {subtitle && <p className="home-subtitle mb-0">{subtitle}</p>}
              </>
            )}
          </Col>
        </Row>
      </Container>
    </header>
  );
}

export default Header;
